import React from "react";
import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";
import CustomLine from "./customLine";

const LoadingInbox = ({ commonLoading, children, className, mapIndex = 5 }) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return commonLoading || loadingStatus
    ? Array.from({ length: mapIndex }, (_, i) => i).map((item) => {
        return (
          <Placeholder
            inverted={isDarkMode}
            className={`${className} h-[85px] rounded-xl !mt-0 mb-[10px] p-[12px] flex items-center justify-between`}
          >
            <div className="flex items-center gap-[20px]  h-full w-full">
              <CustomLine className={`w-[10px] h-[10px]`} circle />
              <div className="flex flex-col  justify-between w-full h-full">
                <div className="flex flex-col gap-[5px]">
                  <CustomLine className={`h-[10px] w-full`} />
                  <CustomLine className={`h-[10px] w-[50%]`} />
                </div>
                <CustomLine className={`h-[8px] w-[80px]`} />
              </div>
            </div>
          </Placeholder>
        );
      })
    : children;
};

export default LoadingInbox;
